import { addClassesLinked } from '@/models/utils'

export const state = () => ({
  isLoading: false,
  course: [],
  classes: [],
  newClasses: [],
  oldClasses: [],
  closedClasses: [],
  certification: true,
})

export const getters = {
  hasClasses(state) {
    return state.classes
  },
  isPendingPayment(state) {
    if (localStorage[localStorage.classId]) {
      const decodeStatus = atob(localStorage[localStorage.classId])
      return ['inadimplente'].includes(decodeStatus)
    }
  },
}

export const mutations = {
  toggleLoading(state) {
    state.isLoading = !state.isLoading
  },
  setClasses(state, classes) {
    const newClasses = classes.filter((classe) => !classe.is_legacy)
    const { activeClasses, classesClosed } =
      actions.getActiveClasses(newClasses)
    state.closedClasses = classesClosed
    state.classes = activeClasses
    state.newClasses = activeClasses
    state.oldClasses = classes.filter((classe) => classe.is_legacy)
  },
  filterNewClasses(state, search) {
    state.newClasses = state.classes.filter((classe) => {
      return classe.name
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036F]/g, '')
        .includes(
          search
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036F]/g, '')
        )
    })
  },
  setCourse(state, course) {
    state.course = course
  },
}

export const actions = {
  async getClasses(store) {
    if (store.state.classes.length !== 0) return

    store.commit('toggleLoading')
    const response = await this.$axios.get('/api/v1/academic/classes')
    const { data } = await this.$axios.get(
      '/api/v1/academic/classes?terminated=true'
    )
    const mergedClasses = [...response.data, ...data]
    const { classesWithoutRepeat } = addClassesLinked(mergedClasses)
    store.commit('setClasses', classesWithoutRepeat)
    store.commit('toggleLoading')
  },
  getActiveClasses(allClasses) {
    const classesClosed = []
    const classes = []
    allClasses.forEach((classe) => {
      classe.terminated ? classesClosed.push(classe) : classes.push(classe)
    })
    return { activeClasses: classes, classesClosed }
  },
}
